import { apiGet, apiPost, apiVersionV3 } from '../../fetch/apiService';
import { exportTypes } from './exportTypes';

export function exportMembers({ exportType, bodyParams = {}, queryParameters }) {
	return apiPost('members/export', bodyParams , {
		export_type: exportType,
		...queryParameters,
	}, {}, apiVersionV3);
}

export function exportMembersStatus(exportId) {
	return apiGet('members/export_status', { export_id: exportId }, {}, apiVersionV3);
}

export function exportReport({ reportId, exportType, additionalParameters }) {
	return apiPost(`reports/${reportId}/export`, additionalParameters || {}, { export_type: exportType });
}

export function exportReportStatus(exportId, { reportId }) {
	return apiGet(`reports/${reportId}/export_status`, { export_id: exportId });
}

export function exportDataSource({ dataSourceId, queryParameters }) {
	return apiPost(`datasources/${dataSourceId}/export/`, {}, queryParameters);
}

export function exportDataSourceStatus(exportId, { dataSourceId }) {
	return apiGet(`datasources/${dataSourceId}/export_status`, { export_id: exportId });
}

export function runExport(exportType, parameters) {
	switch (exportType) {
	case exportTypes.report:
		return exportReport(parameters);
	case exportTypes.datasource:
		return exportDataSource(parameters);
	case exportTypes.members:
		return exportMembers(parameters);
	default:
		throw new Error('Unsupported export type');

	}
}

export function getExportStatus(exportType, exportId, parameters) {
	switch (exportType) {
	case exportTypes.report:
		return exportReportStatus(exportId, parameters);
	case exportTypes.datasource:
		return exportDataSourceStatus(exportId, parameters);
	case exportTypes.members:
		return exportMembersStatus(exportId, parameters);
	default:
		throw new Error('Unsupported export type');
	}
}
